export default "__VITE_ASSET__CFG_dhAS__"